import React from "react";
import Food from "../../data/food";
import { Purchase } from "../../data/purchase";
import { Card } from "../ui/Card";
import { Checkbox } from "../ui/Checkbox";
import { NumberInput } from "../ui/Input";
import { SectionLabel } from "../ui/SectionLabel";
import { SmallIconButton } from "../SmallIconButton";

export function FoodNutritionCard({
  food,
  isCreate,
  nutriValuesPerPortion,
  baseline,
  defaultPurchase,
  onFieldChange,
  onTogglePerPortion,
  onComputeCalories,
  onEditDefaultPurchase,
}: {
  food: Food;
  isCreate: boolean;
  nutriValuesPerPortion: boolean;
  baseline: string;
  defaultPurchase: Purchase | undefined;
  onFieldChange: <K extends keyof Food>(field: K, value: Food[K]) => void;
  onTogglePerPortion: (checked: boolean) => void;
  onComputeCalories: () => void;
  onEditDefaultPurchase: () => void;
}) {
  return (
    <Card className="flex flex-col gap-4 p-4 border-line bg-surface-card">
      <div className="flex flex-col">
        <SectionLabel>Nährwerte</SectionLabel>
        <span className="text-xs text-ink-muted">{baseline}</span>
      </div>

      {isCreate && (
        <label className="flex items-center gap-3 cursor-pointer select-none mb-1">
          <Checkbox
            checked={nutriValuesPerPortion}
            onCheckedChange={onTogglePerPortion}
          />
          <span className="text-sm text-ink">
            Nährwerte pro Portion angeben
          </span>
        </label>
      )}

      <div className="flex flex-col gap-2">
        <div className=" flex flex-col gap-1">
          <label className="text-xs font-semibold text-ink-muted">
            Kalorien (kcal)
          </label>
          <div className="flex gap-2">
            <div className="flex-1">
              <NumberInput
                data-cy="food-kcal-input"
                value={food.kcal}
                onValueChange={(val) => onFieldChange("kcal", val || 0)}
                disabled={!isCreate}
                className="flex-1"
              />
            </div>
            <div className="flex flex-1 gap-2 shrink-0">
              {isCreate && (
                <>
                  <SmallIconButton
                    icon={"calculator"}
                    onClick={onComputeCalories}
                    label={"Kcal berechnen"}
                  />
                </>
              )}
              {!isCreate && defaultPurchase && (
                <SmallIconButton
                  icon="pencil"
                  onClick={onEditDefaultPurchase}
                  label="Standard-Produkt bearbeiten"
                />
              )}
            </div>
            <div className={"flex-1"} />
          </div>
        </div>

        <div className={"flex gap-2"}>
          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-ink-muted">
              Fett (g)
            </label>
            <NumberInput
              data-cy="food-fat-input"
              value={food.fat}
              onValueChange={(val) => onFieldChange("fat", val || 0)}
              disabled={!isCreate}
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-ink-muted">
              KH (g)
            </label>
            <NumberInput
              data-cy="food-carbs-input"
              value={food.carbs}
              onValueChange={(val) => onFieldChange("carbs", val || 0)}
              disabled={!isCreate}
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-ink-muted">
              Protein (g)
            </label>
            <NumberInput
              data-cy="food-protein-input"
              value={food.protein}
              onValueChange={(val) => onFieldChange("protein", val || 0)}
              disabled={!isCreate}
            />
          </div>
        </div>
      </div>
    </Card>
  );
}
